import React, { useState } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faCopy } from '@fortawesome/free-solid-svg-icons';
import { printContract, copyToClipboard } from '../../../utils/contractUtils';

const ContractDetailsModal = ({ contract, onHide, onLoad }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  
  if (!contract) return null;

  const handlePrint = () => {
    if (contract?.contract_text) {
      printContract(contract.contract_text);
    }
  };

  const handleCopy = async () => {
    if (!contract?.contract_text) return;
    
    try {
      const success = await copyToClipboard(contract.contract_text);
      if (success) {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      }
    } catch (error) {
      console.error('Error copying text:', error);
    }
  };

  return (
    <Modal
      show={!!contract}
      onHide={onHide}
      size="lg"
      centered
      className="dark-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>{contract.name || 'Contract Details'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dark-card-alt p-3 overflow-auto" style={{ maxHeight: "400px" }}>
          <pre className="text-light" style={{ whiteSpace: "pre-wrap" }}>
            {contract.contract_text}
          </pre>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <div className="me-auto">
          <Button 
            variant="outline-secondary" 
            className="me-2" 
            onClick={handlePrint}
            disabled={!contract?.contract_text}
          >
            <FontAwesomeIcon icon={faPrint} className="me-2" />
            Print
          </Button>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="copy-tooltip-modal">
                {copySuccess ? 'Copied!' : 'Copy to clipboard'}
              </Tooltip>
            }
          >
            <span>
              <Button 
                variant="outline-secondary" 
                onClick={handleCopy}
                disabled={!contract?.contract_text}
              >
                <FontAwesomeIcon icon={faCopy} className="me-2" />
                {copySuccess ? 'Copied!' : 'Copy'}
              </Button>
            </span>
          </OverlayTrigger>
        </div>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={() => onLoad(contract)}>
          Load Contract
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContractDetailsModal; 